//export class RequisitionFileCabinetListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionFileCabinetListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RequisitionFileCabinetDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RequisitionFileCabinetEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionFileCabinet/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RequisitionFileCabinetFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public requisitionId: IFieldOptions = { field: "requisitionId" };
	public fileCabinetId: IFieldOptions = { field: "fileCabinetId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionId);
		this.push(this.fileCabinetId);
	}
}

export class RequisitionFileCabinetForm implements IFormOptions {
	protected requisitionFileCabinetFormName: string = "requisitionFileCabinetForm";
	protected requisitionFileCabinetFormModel: models.RequisitionFileCabinetDTO = new models.RequisitionFileCabinetDTO();
	protected requisitionFileCabinetFormEndPoints: RequisitionFileCabinetEndPoints = new RequisitionFileCabinetEndPoints();
	protected requisitionFileCabinetFormFields: RequisitionFileCabinetFormFields = new RequisitionFileCabinetFormFields();
	public get name(): string { return this.requisitionFileCabinetFormName };
	public get model(): models.RequisitionFileCabinetDTO { return this.requisitionFileCabinetFormModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionFileCabinetFormEndPoints };
       public set endPoints(requisitionFileCabinetEndPoints: IEntityEndPoints) {
		this.requisitionFileCabinetFormEndPoints = requisitionFileCabinetEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RequisitionFileCabinetFormFields { return this.requisitionFileCabinetFormFields };
}

export class RequisitionFileCabinetListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public requisitionId: IColumnOptions = { field: "requisitionId" };
	public fileCabinetId: IColumnOptions = { field: "fileCabinetId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionId);
		this.push(this.fileCabinetId);
	}
}

export class RequisitionFileCabinetList implements IGridOptions {
	protected requisitionFileCabinetListName: string = "requisitionFileCabinetList";
	protected requisitionFileCabinetListModel: models.RequisitionFileCabinetDTO = new models.RequisitionFileCabinetDTO();
	protected requisitionFileCabinetListEndPoints: RequisitionFileCabinetEndPoints = new RequisitionFileCabinetEndPoints();
	protected requisitionFileCabinetListColumns: RequisitionFileCabinetListColumns = new RequisitionFileCabinetListColumns();
	public requisitionFileCabinetForm: RequisitionFileCabinetForm = new RequisitionFileCabinetForm();
	public get name(): string { return this.requisitionFileCabinetListName };
	public get model(): models.RequisitionFileCabinetDTO { return this.requisitionFileCabinetListModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionFileCabinetListEndPoints };
	public set endPoints(requisitionFileCabinetEndPoints: IEntityEndPoints) {
		this.requisitionFileCabinetListEndPoints = requisitionFileCabinetEndPoints;
		this.requisitionFileCabinetForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RequisitionFileCabinetListColumns { return this.requisitionFileCabinetListColumns };
}

export class RequisitionFileCabinetEntity implements IEntityOptions {
	protected requisitionFileCabinetEntityName: string = "requisitionFileCabinetEntity";
	protected requisitionFileCabinetEntityModel: models.RequisitionFileCabinetDTO = new models.RequisitionFileCabinetDTO();
	protected requisitionFileCabinetEntityEndPoints: RequisitionFileCabinetEndPoints = new RequisitionFileCabinetEndPoints();
	protected requisitionFileCabinetEntityList: RequisitionFileCabinetList = new RequisitionFileCabinetList();
	public get name(): string { return this.requisitionFileCabinetEntityName };
	public get model(): models.RequisitionFileCabinetDTO { return this.requisitionFileCabinetEntityModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionFileCabinetEntityEndPoints };
	public set endPoints(requisitionFileCabinetEndPoints: IEntityEndPoints) {
		this.requisitionFileCabinetEntityEndPoints = requisitionFileCabinetEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RequisitionFileCabinetList { return this.requisitionFileCabinetEntityList };
	public get form(): RequisitionFileCabinetForm { return this.grid.requisitionFileCabinetForm };
	constructor(name?: string) {
		if (name) this.requisitionFileCabinetEntityName = name;
		this.endPoints = this.requisitionFileCabinetEntityEndPoints;
	}
};
//export class RequisitionFileCabinetGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RequisitionFileCabinetForm = new RequisitionFileCabinetForm();
//};

//export class RequisitionFileCabinetListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RequisitionFileCabinetList = new  RequisitionFileCabinetList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RequisitionFileCabinetBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionFileCabinetGeneratedForm}];
//};

